import { appStore } from "@app/store/store"
import { ApiErrorHandler } from "@app/utils/apiErrorHandler"
import { IframeMessages } from "@app/utils/constants"
import localStore from "@app/utils/localStore"
import tracking from "@app/utils/tracking"
import { createApi, createBaseQuery } from "@tecreation/js-state-react"

let refreshCall

const baseQueryOptions = {
	baseUrl: () => {
		return "/api/auth"
	},
	prepareHeaders: headers => {
		headers.set("apiKey", appStore.get("settings.connectorKey"))
		headers.set("Accept", "application/json")
		if (headers.get("content-type") == null && headers.get("enctype") !== "multipart/form-data") {
			headers.set("content-type", "application/json")
		}

		return headers
	},
	onError: ApiErrorHandler,
}

export const apiAuth = createApi("authApi", appStore, createBaseQuery(baseQueryOptions), {
	keepUnusedDataFor: 0,
})

const useRefresh = apiAuth.mutation({
	builder: () => {
		return {
			url: "refresh",
			body: {
				flow: appStore.get("core.flow") || "guest",
			},
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			appStore.set("core.accessToken", response.data.token)
		}
		return response
	},
})

export const useLogout = apiAuth.mutation({
	builder: () => ({
		url: "logout",
		body: {
			flow: "relation",
		},
	}),
	transformResponse: response => {
		window.parent.postMessage(IframeMessages.deleteRelationSessionToken + ";" + 123, "*")
		return response
	},
})

export const refreshToken = () => {
	if (refreshCall) {
		return refreshCall
	}

	refreshCall = useRefresh.blank().then(e => {
		refreshCall = undefined
		return e
	})
	return refreshCall
}

export const useLogin = apiAuth.mutation({
	builder: params => {
		return {
			url: "login",
			body: {
				flow: "relation",
				identifier: params.email,
				secret: params.password,
			},
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			appStore.set("core.accessToken", response.data.token)
			appStore.set("core.flow", "relation")
			localStore.setItem("flow", "relation")
			tracking.login("Kunde")
			window.parent.postMessage(IframeMessages.setRelationSessionToken + ";" + 123, "*")
		}

		return response
	},
	invalidatesTags: ["RELATION_TOKEN"],
})
